import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import AdminStopView from "../stops/mapPage";

export default function SchoolStopMonitor() {
  const { stopId } = useParams();
  const location = useLocation();

  const { selectedStopData, localStopsData } = useMemo(() => {
    if (location.state?.selectedStopData) {
      return {
        selectedStopData: location.state.selectedStopData,
        localStopsData: location.state.localStopsData || [],
      };
    }

    try {
      const storedStop = localStorage.getItem(`schoolStopMonitor:${stopId}`);
      const storedStops = localStorage.getItem("schoolStopMonitor:allStops");
      return {
        selectedStopData: storedStop ? JSON.parse(storedStop) : null,
        localStopsData: storedStops ? JSON.parse(storedStops) : [],
      };
    } catch (error) {
      console.error("Error reading school stop monitor data:", error);
      return { selectedStopData: null, localStopsData: [] };
    }
  }, [location.state, stopId]);
  return (
    <AdminStopView
      selectedStopData={selectedStopData}
      localStopsData={localStopsData}
      isSchoolMonitor={true}
    />
  );
}